import { LogGroup, Log } from "../.././MyHelpers";
import { IReelMapper } from "./ReelSetMapper";

export type ReelMapperOverlayClearCallback = (reelIndex: number) => void;


export class ReelSymbolsToDisplay
{
	reelPositionIndex: number;
	symbolIndex: number;
	slicing: boolean;
}


export class ReelMapper implements IReelMapper
{
	private reelIndex: number = 0;
	private reel: number[] = [];
	private distance: number = 0;
	private startPosition: number = 0;
	private currentPosition: number = 0;

	private symbolsChanged: boolean = false;


	private slice: boolean = false; // are we ready to slice?
	private sliceDistance: number = 0; // where do we slice?
	private slicePosition: number = 0; // what is the new position after the slice?


	private reelWindowHeight: number = 0; // how high is the reel window - to keep overlay the same size
	private reelOverlayPosition: number = 0;
	private reelOverlay: number[] = null;

	public static readonly NoOverlaySymbolIndex = -1;

	private logGroup: LogGroup = null;

	protected numDisplayedSymbols: number = 1;

	public constructor(reelIndex: number, logGroup: LogGroup, reelWindowHeight: number, numDisplayedSymbols: number) {
		this.logGroup = logGroup.Add(["ReelMapper", "" + reelIndex]);
		this.reelIndex = reelIndex;

		this.reelWindowHeight = reelWindowHeight;
		this.numDisplayedSymbols = numDisplayedSymbols;
	}

	public SetReel(reel: number[], startPosition: number/*, reelWindowHeight: number*/): void {
		this.reel = reel;

		//this.reelWindowHeight = reelWindowHeight;

		this.ClearOverlay();
		this.SymbolsChanged();
	}

	public Start(): void {
		this.slice = false;
		this.startPosition = this.slicePosition;

		// DISTANCE STARTS FROM 0 WHEN ANIMATION STARTS
		// reset overlay to 0, so to keep symbols rolling off screen
		this.distance = 0;
		this.reelOverlayPosition = 0;
	}

	public SetTarget(slicePosition: number): void {
		this.slicePosition = slicePosition;
	}

	public Slice(sliceDistance: number/*, slicePosition: number*/) {
		this.slice = true;
		this.sliceDistance = sliceDistance;
		//this.slicePosition = slicePosition;
	}

	// distance is in number of symbols
	public Update(distance: number): void {
		//// Log.Debug(this.logGroup, "moved " + distance + " from " + this.startPosition);

		this.distance = distance;
		let newPosition: number = (this.startPosition + distance) % this.reel.length;
		if (newPosition != this.currentPosition) {
			this.SymbolsChanged();
		}

		// if(newPosition == NaN)
		// {
		// 	debugger;
		// }

		this.currentPosition = newPosition;

		// clear overlay, when pushed below visible line ( > window height)
		if (this.reelOverlay != null && distance >= this.reelOverlayPosition + this.reelWindowHeight) {
			// Log.Debug(this.logGroup, "overlay has moved " + (this.distance - this.reelOverlayPosition) + ", clearing...");
			this.ClearOverlay();
		}
	}

	private SymbolsChanged(): void {
		this.symbolsChanged = true;
	}

	public DidSymbolsChange(): boolean {
		let r = this.symbolsChanged;
		this.symbolsChanged = false;

		return r;
	}

	public IsOverlayActivated(){
		return this.overlaySet;
	}

	public GetSymbols2(): ReelSymbolsToDisplay[]
	{
		let result: ReelSymbolsToDisplay[] = [];

		// current position on reel
		let p = this.currentPosition;

		// are we slicing?
		let slicing = false;
		let sp = this.slicePosition;

		let s = 0; // symbol position on reel

		let usingOverlay: boolean = false;
		let op = 0; // overlay position

		let symbolIndex: number = 0;

		for (let i = 0; i < this.numDisplayedSymbols; i++) {

			// start slicing, when the slice distance comes
			if (this.slice && !slicing && this.distance + i >= this.sliceDistance) {
				slicing = true;
			}

			// are we slicing yet?
			if (slicing) {
				// take symbols from slice position on
				s = sp;
				sp = (sp + 1) % this.reel.length; // move to next symbol on reel
			}
			else {
				// take symbols from current position on
				s = p;
				p = (p + 1) % this.reel.length; // move to next symbol on reel
			}

			// do we start overlay?
			if (!usingOverlay && this.reelOverlay != null)
			{
				// overlay window overlaps with reel window?
				if (this.distance + i >= this.reelOverlayPosition && this.distance + i < this.reelOverlayPosition + this.reelWindowHeight)
				{
					// overlay window offset
					op = this.distance + i - this.reelOverlayPosition;

					usingOverlay = true;
					//// Log.Debug(this.logGroup, "Starting overlay on symbol " + i + ", (s=" + s + ", overlayPosition=" + this.reelOverlayPosition);
				}
			}

			// do we use overlay?
			if (usingOverlay && op < this.reelOverlay.length) {
				symbolIndex = this.reelOverlay[op];

				if (symbolIndex == ReelMapper.NoOverlaySymbolIndex) {
					// overlay is empty
					//// Log.Debug(this.logGroup, "Symbol " + i + " regular " + this.reel[s] + " overlay " + symbolIndex + " empty");

					// use original symbol
					symbolIndex = this.reel[s];
				}
				else {
					//// Log.Debug(this.logGroup, "Symbol " + i + " regular " + this.reel[s] + " overlay " + symbolIndex + " reelOverlayPosition=" + JSON.stringify(this.reelOverlayPosition) + ", overlay=" + JSON.stringify(this.reelOverlay));
				}

				op++;
			}
			else {
				//// Log.Debug(this.logGroup, "Symbol " + i + " regular " + this.reel[s]);

				symbolIndex = this.reel[s];
			}

			result.push({
				reelPositionIndex: s,
				symbolIndex: symbolIndex,
				slicing: slicing
			});
			//result.push(symbolIndex);
		}

		if (usingOverlay) {
			// Log.Debug(this.logGroup, "Using overlay: " + JSON.stringify(this.reelOverlay));
		}

		//// Log.Debug(this.logGroup, JSON.stringify(result));

		return result;
	}

	public GetSymbols(numberOfSymbols: number): number[] {
		let result: number[] = [];

		// current position on reel
		let p = this.currentPosition;

		// are we slicing?
		let slicing = false;
		let sp = this.slicePosition;

		let s = 0; // symbol position on reel

		let usingOverlay: boolean = false;
		let op = 0; // overlay position

		let symbolIndex: number = 0;

		for (let i = 0; i < numberOfSymbols; i++) {

			// start slicing, when the slice distance comes
			if (this.slice && !slicing && this.distance + i >= this.sliceDistance) {
				slicing = true;
			}

			// are we slicing yet?
			if (slicing) {
				// take symbols from slice position on
				s = sp;
				sp = (sp + 1) % this.reel.length; // move to next symbol on reel
			}
			else {
				// take symbols from current position on
				s = p;
				p = (p + 1) % this.reel.length; // move to next symbol on reel
			}

			// do we start overlay?
			if (!usingOverlay && this.reelOverlay != null)
			{
				// overlay window overlaps with reel window?
				if (this.distance + i >= this.reelOverlayPosition && this.distance + i < this.reelOverlayPosition + this.reelWindowHeight)
				{
					// overlay window offset
					op = this.distance + i - this.reelOverlayPosition;

					usingOverlay = true;
					//// Log.Debug(this.logGroup, "Starting overlay on symbol " + i + ", (s=" + s + ", overlayPosition=" + this.reelOverlayPosition);
				}
			}

			// do we use overlay?
			if (usingOverlay && op < this.reelOverlay.length) {
				symbolIndex = this.reelOverlay[op];

				if (symbolIndex == ReelMapper.NoOverlaySymbolIndex) {
					// overlay is empty
					//// Log.Debug(this.logGroup, "Symbol " + i + " regular " + this.reel[s] + " overlay " + symbolIndex + " empty");

					// use original symbol
					symbolIndex = this.reel[s];
				}
				else {
					//// Log.Debug(this.logGroup, "Symbol " + i + " regular " + this.reel[s] + " overlay " + symbolIndex + " reelOverlayPosition=" + JSON.stringify(this.reelOverlayPosition) + ", overlay=" + JSON.stringify(this.reelOverlay));
				}

				op++;
			}
			else {
				//// Log.Debug(this.logGroup, "Symbol " + i + " regular " + this.reel[s]);

				symbolIndex = this.reel[s];
			}

			result.push(symbolIndex);
		}

		if (usingOverlay) {
			// Log.Debug(this.logGroup, "Using overlay: " + JSON.stringify(this.reelOverlay));
		}

		//// Log.Debug(this.logGroup, JSON.stringify(result));

		return result;
	}

	protected overlaySet : boolean = false;
	public SetOverlay(symbols: number[]) {
		if (symbols.length != this.reelWindowHeight) {
			Log.Error(this.logGroup, "Unable to set reel overlay");
		}
		else {

			// Log.Debug(this.logGroup, "Overlay set: " + JSON.stringify(symbols));

			this.reelOverlay = symbols;
			this.reelOverlayPosition = this.distance; // + this.distance;
			this.SymbolsChanged();
			this.overlaySet = true;
		}
	}

	public ClearOverlay() {
		// Log.Debug(this.logGroup, "Clearing overlay");
		this.reelOverlay = null;
		this.SymbolsChanged();

		this.OnClearOverlay();
		this.overlaySet = false;
	}

	private clearOverlayCallbacks: ReelMapperOverlayClearCallback[] = [];
	public AddClearOverlayCallback(callback: ReelMapperOverlayClearCallback) {
		this.clearOverlayCallbacks.push(callback);
	}

	private OnClearOverlay() {
		for (let i = 0; i < this.clearOverlayCallbacks.length; i++) {
			this.clearOverlayCallbacks[i](this.reelIndex);
		}
	}
}